import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_poll_quiz = _resolveComponent("poll-quiz");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_quiz_viewer_layout = _resolveComponent("quiz-viewer-layout");
  return _ctx.pollQuestion ? (_openBlock(), _createBlock(_component_quiz_viewer_layout, {
    key: 0
  }, _createSlots({
    content: _withCtx(() => [_createVNode(_component_poll_quiz, {
      question: _ctx.pollQuestion,
      "poll-results-id": _ctx.pollResultsId,
      "quiz-statistics-data": _ctx.quizStatisticsData,
      "user-answers-ids": _ctx.userRealtimeAnswersIds,
      "is-result-mode": _ctx.quizAnswered,
      "can-edit": _ctx.canEdit,
      "is-speach-template": _ctx.isSpeachTemplate,
      onAnswerChange: _ctx.onQuizAnswerChange
    }, null, 8, ["question", "poll-results-id", "quiz-statistics-data", "user-answers-ids", "is-result-mode", "can-edit", "is-speach-template", "onAnswerChange"])]),
    _: 2
  }, [!_ctx.quizAnswered ? {
    name: "footer",
    fn: _withCtx(() => [_createVNode(_component_standard_button, {
      label: _ctx.$t('view.speach.pollQuiz.confirmButton'),
      disabled: _ctx.canEdit || !_ctx.userRealtimeAnswersIds?.length,
      onAction: _cache[0] || (_cache[0] = $event => _ctx.saveAnswerAndDisplayResultPage())
    }, null, 8, ["label", "disabled"])]),
    key: "0"
  } : undefined]), 1024)) : _createCommentVNode("", true);
}